export default __webpack_public_path__ + "static/media/logo.01f35ab0.svg";